import { useState, memo } from 'react';

import Image from 'next/image';
import PropTypes from 'prop-types';

// const Loader = memo(({type = 'primary', height, width}) => (
//   <div className={`full-width full-height d-inline-block`}>
//     <div className={`spinner-border text-${type}`} role="status" style={{height, width}}>
//       <span className="sr-only">Loading...</span>
//     </div>
//   </div>
// ));

const ImageLoader = memo(({ fallback, src, objectFit, ...props }) => {
  const [error, setError] = useState(false);

  if (!src || error) {
    return fallback;
  }

  return <Image {...props} objectFit={objectFit} onError={() => setError(true)} src={src} />;
});

ImageLoader.displayName = 'ImageLoader';

ImageLoader.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, () => null])
};
ImageLoader.defaultProps = {
  fallback: <img alt='Fallback Image' height={40} src='/images/fallback-img.svg' width={40} />,
  type: 'contain',
  objectFit: 'contain'
};

export default ImageLoader;
